import * as React from 'react';
import * as ReactDom from 'react-dom';
import { Link, RouteComponentProps } from 'react-router-dom';
import * as Exceljs from '../../actions/ExportToExcel.js';
import { SendEmailControl } from './../sharedcomponents/SendEmailControl';
import { PopupWindow } from './../sharedcomponents/PopupWindow';
import { ExportToExcel } from './../sharedcomponents/ExportToExcel';
import Formatters from '../../actions/Formatters';
import $ from 'jquery';
import Workbook from 'react-excel-workbook';
var Excel = Exceljs.default;
var Config: any = require('../../Config.json');

interface ToolBarState {
    renderEmailHtml: any;
    modelDialogHtml: any;
    exportFields: ExportFields;
    excelData: any[];
    headerData: any[];
    isDownload: boolean;
    isFileDownload: boolean;
    excelGridData: any[];
    formName: string;
    fileTitle: string;
    sheetInfo: any;
    gridApiParams: any;
}

class ReeferHistoryFilter {
    FromDate: string;
    ToDate: string;
    Units: string;
}
class ExportFields {
    ExportData: string;
}

var self;
var ProcessfirstCellOnlyRowIndex = -1;


export class GridToolBarControl extends React.Component<any, ToolBarState> {
    constructor(props: any) {
        super(props);
        var filterSet = new ReeferHistoryFilter();
        var exportData = new ExportFields();
        this.state = { renderEmailHtml: '', modelDialogHtml: '', exportFields: exportData, excelData: [], headerData: [], isDownload: false, excelGridData: this.props.gridData, formName: this.props.formName, fileTitle: this.props.formName, sheetInfo: '', gridApiParams: this.props.gridApiParams, isFileDownload: false };
        self = this;
    }

    componentDidMount() {
        this.renderSheets();
    }

    renderEmailControl() {
        return <SendEmailControl reeferStatusResult={this.props.gridData} gridApiParams={this.props.gridApiParams} columnDefinition={this.props.colDefs} parentchild={this.props.parentchild} formname={this.props.formName} />;
    }

    modelDialogHtml() {
        return <div className="modal sendEmail-position" role="dialog" id={this.props.formName}>
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Email</h5>
                        <button type="button" className="btn-close" aria-label="Close" onClick={this.closeToolBarModel.bind(this)}><span aria-hidden="true">&times;</span></button>
                       
                    </div>
                    <div className="modal-body">
                        {this.state.renderEmailHtml}
                    </div>
                </div>
            </div>
        </div>
    }

    RefreshData() {
        this.props.refreshGrid();
    }

    ExportToExcel() {
        if (this.props.gridData != undefined && this.props.gridData != null && this.props.gridData.length > 0) {
            this.setState({ gridApiParams: this.props.gridApiParams });

            $("#globalLoader").show();
            this.setState({ isFileDownload: true },
                () => {                
                    var IsGroupsExist = this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false;
                    if (IsGroupsExist) {
                        this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel(
                            {
                                columnGroups: false,
                                allColumns: true,
                                processGroupHeaderCallback: this.myGroupHeaderCallback, processHeaderCallback: this.myHeaderCallback,
                                processRowGroupCallback: this.myRowGroupCallback, processCellCallback: this.myCellCallback,
                                fileName: this.getFileName(this.GetExportFileName()),
                                sheetName: this.getFileName(this.GetExportFileName()),
                            })
                    }
                    else {
                        var allColumns = this.props.gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
                        for (var i = allColumns.length - 1; i >= 0; i--) {
                            if (allColumns[i].colDef.headerName === 'Group') {
                                 allColumns.splice(i, 1);
                            }
                        }
                        this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel(
                            {
                                columnGroups: true,
                                //allColumns: true,
                                columnKeys: allColumns,
                                skipGroups: true,
                                processHeaderCallback: this.myHeaderCallback,processCellCallback: this.myCellCallback,
                                fileName: this.getFileName(this.GetExportFileName()),
                                sheetName: this.getFileName(this.GetExportFileName()),
                            })

                    }
                }
            );

            //if (this.state.isFileDownload) {
            //    this.showMessageAndClosePopup();
            //}

            setTimeout(() => {
                this.setState({ isFileDownload: true }, () => { this.showMessageAndClosePopup(); })
            }, 2000);
        }
        else {
            $("#globalLoader").hide();
            PopupWindow.showErrorMessage("Alert", "No Data to Export.");
        }

    }

    showMessageAndClosePopup() {
        if (this.state.isFileDownload) {
            $("#globalLoader").hide();
            PopupWindow.showErrorMessage("Alert", "Data exported successfully.");
            this.setState({ isFileDownload: false });
        }
    }

    getFileName(formName: string) {
        var currentDate = new Date();
        return formName + currentDate.getDate() + currentDate.getMonth() + currentDate.getFullYear() + currentDate.getHours() + currentDate.getMinutes() + currentDate.getSeconds();
    }

    GetExportFileName() {
        var FileName = this.props.formName;

        switch (FileName) {

            default:
                return FileName;
        }
    }

    getGroupDisplayValueName(params) {
        if (params != undefined && params != null) {

            var fieldName = params.node.field;
            var fieldValue = params.node.key;

            //var colDef = params.node.columnApi.columnController.rowGroupColumns.filter(x => x.colId == fieldName);
            //var columnDisplayName = colDef[0].colDef.headerName;            
            var columnDisplayName = params.node.rowGroupColumn.colDef.headerName;//WI 26719

            if (fieldValue.toString().trim() == "-999" && (fieldName === 'BatteryVoltage' || fieldName === 'DoorSensorBatteryVoltage'))
                return "*No " + columnDisplayName;

            if (fieldValue == "-NA-" || fieldValue == "null")
                return "*No " + columnDisplayName;

            if (fieldValue.toString().trim() == "-999")
                return "OOR";

            switch (fieldName) {
                case "IgnitionOn":
                    return Formatters.GensetSwitchFormatterGroupingExcel(fieldValue);
                case "GensetRunning":
                    return Formatters.EngineSortingFormatterGroupingExcel(fieldValue);
                case 'UnitEventDTTM': case 'DataLoggerDtm': case 'ModifiedDTTM': case 'EventDTTM': case 'R_EventDTTM': case 'R_ModifiedDTTM': case 'DLEventDTTM': case 'InsertedDttm': case 'UpdatedDttm': case 'DoorEventDtm':
                    return Formatters.dateTypeFormatterGrouping(fieldValue);

                case 'DeviceTemp':
                    {
                        return Formatters.TemperatureFormatterExcelForDeviceTemp(params);
                    }
                case 'IsInsideGeofence': case 'IsActive': case 'StateCd':
                    {
                        return Formatters.YesNoConverterforExcel(fieldValue);
                    }

                case "DevicePowerSourceCd":
                    return Formatters.PowerStateFormatterGroupingForExcel(fieldValue);//done

                case 'BatteryVoltage':
                    {
                        return (fieldValue == "" || fieldValue == null || fieldValue === '-NA-' || fieldValue === '-999') ? '-NA-' : Formatters.BattVoltageSortingGrouping(fieldValue);
                    }
                case 'DoorSensorBatteryVoltage':
                    {
                        var AssetType;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                            AssetType = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].AssetType;
                        }
                        if(AssetType != null && AssetType != undefined && AssetType.toString().toUpperCase().trim() == "D")
                            return (fieldValue == "" || fieldValue == null || fieldValue === '-NA-' || fieldValue === '-1') ? '-NA-' : Formatters.DoorBattPctSortingGrouping(fieldValue);
                    }
                case 'DeviceConfig': case 'GuestReeferMode':
                    {

                        return Formatters.GuestReeferModeFormatterForExcel(fieldValue);
                    }

                case 'RCDPOWERSOURCECD': if (params.value != undefined && params.value != null) return Formatters.rcdPowerSourceFormatterforExcel(fieldValue);

                case "CustomerName":
                    {
                        if (columnDisplayName == 'Assigned To')
                            return fieldValue == JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName ? "-NA-" : fieldValue;
                        else
                            return fieldValue;
                    }
                case "ReeferOEMTypeCd": case "OEMTypeCD":// WI-26787
                    return Formatters.OEMTypeFormatterGrouping(fieldValue);
                case "RSSI":
                    return Formatters.RSSIFormatterGroupingForExcel(fieldValue);
                case "DeviceConfig":
                    return Formatters.GuestReeferModeGrouping(fieldValue);

                case "AssetType":
                    return Formatters.AssetTypeGrouping(fieldValue);
                case "GeofenceCategoryCd":
                    return Formatters.GeofenceTypeGrouping(fieldValue);
                case "FilerepositoryActionCD":
                    return Formatters.FileStatusGrouping(fieldValue);
                case "GPSCoords":
                    return Formatters.GPSCoordsFormatterForExcel(fieldValue, params);
                case "CCSeverityLevel":
                    return Formatters.CargoCareFormatterGroupingForExcel(fieldValue); //RCNG - 241 Renamed Normal to Assigned
                case "DoorOpen":
                    return Formatters.DeviceDoorFormatterGrouping(fieldValue);
                default:
                    return fieldValue;

            }

        }
    }

    myCellCallback(params) {
        var returnValue;

        if (params.node.group && ProcessfirstCellOnlyRowIndex != params.node.rowGroupIndex) {
            ProcessfirstCellOnlyRowIndex = params.node.rowGroupIndex
            if (params.node.key != null && params.node.key != undefined)
                return self.myRowGroupCallback(params);
        }

        if (params.node.group && params.column.colId === "0") {
            return self.myRowGroupCallback(params);
        }

        if (!params.node.group) {
            switch (params.column.colId) {

                case 'RCDID': case 'RCDId': case 'TowerBaseStationID': case 'ICCID': case 'MSISDN': case 'SIM_IMSI': case 'RcdID': case 'DeviceNumber':
                    {
                        if (params.value == undefined || params.value == "-NA-")
                            returnValue = "-NA-";
                        else
                            returnValue = params.value;
                    }
                    break;

                case 'Name': case 'Tag': case 'Address': case 'ProfileCode': case 'ProfileCodeDescription': case 'InsertedBy': case 'UpdatedBy':
                    {
                        if (params.value != undefined && params.value != null)
                            returnValue = Formatters.stringTypeFormatterChildFormsNew(params.value);
                        else
                            returnValue = "-NA-";
                    }
                    break;
                case 'Coordinates':
                    if (params.value != undefined && params.value != null)
                        returnValue = Formatters.GeofenceCoordinatesFormatterforExcel(params.value);
                    else
                        returnValue = "-NA-";
                    break;
                case 'DeviceTemp':
                    {
                        if (params != undefined && params != null)
                            returnValue = Formatters.TemperatureFormatterExcelForDeviceTemp(params);
                        else
                            returnValue = "-NA-";
                    }
                    break
                case 'UnitEventDTTM': case 'DataLoggerDtm': case 'ModifiedDTTM': case 'EventDTTM': case 'R_EventDTTM': case 'R_ModifiedDTTM': case 'CreatedDTTM': case 'CreateDTTM': case 'StatusDate': case 'SubmittedOn': case 'TTL': case 'ExpirationTime': case 'PTRDateTime': case 'DLEventDTTM': case 'InsertedDttm': case 'UpdatedDttm': case 'DoorEventDtm':
                    {
                        //if (params.value != undefined && params.value != null)
                        returnValue = Formatters.dateTypeFormatterforExcel(params.value);
                    }
                    break

                case 'IsInsideGeofence': case 'IsActive': case 'HasFuelSensor': case 'HasOilPressureSwitch': case 'HasDoorSensor': case 'IsDeployed': case 'DCXDownloads': case 'StateCd':
                    {
                        //if (params.value != undefined && params.value != null)
                        returnValue = Formatters.YesNoConverterforExcel(params.value);
                    }
                    break
                case 'ReeferOEMTypeCd': case 'ÓEMTypeCD':
                    {
                        //if (params.value != undefined && params.value != null)
                        returnValue = Formatters.GetOEMTypeDescription(params.value);
                    }
                    break;

                case 'BatteryVoltage':
                    {
                        if (params.value != undefined && params.value != null)
                            returnValue = Formatters.BattVoltageFormatterforExcel(params.value);
                    }
                    break;
                case 'DoorSensorBatteryVoltage':
                    {
                        if (params.node.data.AssetType != undefined && params.node.data.AssetType != null && params.node.data.AssetType.toString().toUpperCase().trim() == "D") {
                            if (params.node.data.DoorSensorBatteryVoltage != undefined && params.node.data.DoorSensorBatteryVoltage != null)
                                returnValue = Formatters.DoorBattPctFormatterforExcel(params.node.data.DoorSensorBatteryVoltage);
                        }
                        else
                        {
                            if (params.value != undefined && params.value != null)
                                returnValue = Formatters.BattVoltageFormatterforExcel(params.value);
                        }
                    }
                    break;
                case 'DeviceConfig': case 'GuestReeferMode':
                    {
                        if (params.value != undefined && params.value != null)
                            returnValue = Formatters.GuestReeferModeFormatterForExcel(params.value);
                    }
                    break;

                case 'RCDPOWERSOURCECD': if (params.value != undefined && params.value != null) returnValue = Formatters.rcdPowerSourceFormatterforExcel(params.value);
                    break;


                case 'GPSLastLock': if (params.value != undefined && params.value != null) returnValue = Formatters.secondsToTimeConverterForExcel(params.node.data.GPSLastLock); break;

                case 'IgnitionOn': if (params.value != undefined && params.value != null) returnValue = Formatters.gensetSwitchFormatterForExcel(params.value); break;

                case 'CustomerName':
                    {
                        if (params.column.colDef.headerName == 'Assigned To')
                            returnValue = Formatters.stringTypeFormatterFor3PExcel(params.value);
                        else
                            returnValue = params.value;
                    }
                    break;

                case "RSSI": if (params.value != undefined && params.value != null) returnValue = params.node.data.RSSI; break;

                case "GetFileRepositoryActionDesc":
                    {
                        returnValue = Formatters.GetFileRepositoryActionDesc(params.value);
                    }
                    break;

                case "RunState": returnValue = Formatters.runStateFormatterforExcel(params.node.data.RunState.toUpperCase().trim()); break;
                
                case 'Status': 
                    {
                        if (params.node.data.Status != undefined || params.node.data.Status != "-NA-" && params.node.data.Status != null)
                            returnValue = params.node.data.Status.trim();
                        else
                            returnValue = "-NA-";
                    }
                    break;
                case "RcdPowerSourceCd": returnValue = Formatters.rcdPowerSourceFormatterforExcel(params.value); break;

                case 'ManufacturedDate':
                    {
                        returnValue = Formatters.YearFromdateTypeFormatterForExcel(params.value);
                    }
                    break;
                case 'AssetType': returnValue = Formatters.AssetTypeFormatterForExcel(params.value);
                    break;
                case 'GeofenceCategoryCd': if (params.value != undefined && params.value != null) returnValue = Formatters.fenceTypeFormatterForExcel(params.value);
                    break;
                case 'GensetRunning': {
                    if (params.value != undefined && params.value != null) {
                        // Start WI-26787
                        //var HasOilPressureSwitch;
                        //if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        //    && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        //    && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        //    HasOilPressureSwitch = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].HasOilPressureSwitch;
                        //}
                        //else {
                        //    HasOilPressureSwitch = false;
                        //}
                        // End WI-26787
                        //if (HasOilPressureSwitch != undefined && HasOilPressureSwitch != null)
                        var isGensetRunning = {
                            GensetRunning: params.node.data.GensetRunning,
                            HasOilPressureSwitch: params.node.data.HasOilPressureSwitch,
                            OEMTypeCD: params.node.data.OEMTypeCD
                        };
                        returnValue = Formatters.EngFormatterforExcel(isGensetRunning);
                    }
                }
                    break;

                case 'DevicePowerSourceCd': {
                    if (params.value != undefined && params.value != null) {
                        var DeviceConfig;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                            DeviceConfig = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceConfig;
                        }
                        else {
                            DeviceConfig = false;
                        }

                        var DeviceType;
                        if (params.node.rowIndex != undefined && params.node.rowIndex != null
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                            && self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                            DeviceType = self.state.gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceType;
                        }
                        else {
                            DeviceType = "";
                        }

                        var ispwrStateFormatter = {
                            DeviceType: params.node.data.DeviceConfig,
                            DevicePowerSourceCd: params.node.data.DevicePowerSourceCd,
                            DeviceTypeCd: params.node.data.DeviceType
                        };
                        
                        //if (DeviceType != undefined && DeviceType != null && DeviceConfig != undefined && DeviceConfig != null)
                        return Formatters.pwrStateFormatterforExcel(ispwrStateFormatter);
                    }
                }
                    break;
                case 'CO2Setpoint': case 'CO2Reading': case 'O2Setpoint': case 'O2Reading': case 'EvaporatorTemp':
                case 'CompositeSuctionPressure': case 'CompressorSuctionTemp': case 'DischargePressure': case 'CompressorDischargeTemp':
                case 'CondenserTemperature': case 'CondenserFanOutPut': case 'LowSpeedEvaporatorFanOutPut': case 'HighSpeedEvaporatorFanOutPut':
                case 'HeaterOnTime': case 'HotGasValveOpening': case 'EconomizerValveOpening': case 'CompressorFrequency': case 'VentPositionSensorCMH':
                case 'TotalCurrentDraw': case 'LineVoltage1': case 'LineVoltage2': case 'LineVoltage3': case 'VFD': case 'LineFrequency':
                    {
                        if (params.value != undefined && params.value != null)
                            returnValue = Formatters.sensorDataFormatterforExcel(params.value);
                        else
                            returnValue = "-NA-";
                    }
                    break;
                case 'SetPoint': case 'SupplyTemp1': case 'SupplyTemp2': case 'ReturnTemp1': case 'ReturnTemp2':
                case 'AmbientTemp': case 'EvaporatorTemp': case 'CompressorSuctionTemp': case 'CompressorDischargeTemp':
                case 'CondenserTemperature': case 'USDA1Temp': case 'USDA2Temp': case 'USDA3Temp': case 'Cargo4Temp': case 'SensorSupplyTemp1': case 'SensorReturnTemp1':
                    {
                        if (params.value != undefined && params.value != null)
                            returnValue = Formatters.TemperatureFormatterforExcel(params.value);
                        else
                            returnValue = "-NA-";
                    }
                    break
                case 'DeviceTemp': 
                    {
                        if (params != undefined && params != null)
                            returnValue = Formatters.TemperatureFormatterExcelForDeviceTemp(params);
                        else
                            returnValue = "-NA-";
                    }
                    break
                case 'TemperatureUnit':
                    {
                        if (params.value != undefined && params.value != null)
                            returnValue = Formatters.TemperatureFormatterForBookingforExcel(params.value);
                        else
                            returnValue = "-NA-";
                    }
                    break
                case 'CCSeverityLevel':
                    {
                        if (params.value != undefined && params.value != null) {

                            var IsCargoCare = {
                                isCargocare: params.node.data.IsCargoCare,
                                CCSeverityLevel: params.node.data.CCSeverityLevel
                            };
                            returnValue = Formatters.CargoCareFormatterforExcel(IsCargoCare);
                        }
                        else
                            return "-NA-";
                    }
                    break;
                case 'MASeverityLevel':
                    {
                        returnValue = Formatters.statusIndicatorforALMforExcel(params.node.data.MASeverityLevel);
                    }
                    break;
                case 'AlarmsList': returnValue = Formatters.AlarmListFormatterforExcel(params.value); break;
                case 'Humidity':
                    {
                        var isHumidity = {
                            Humidity: params.node.data.Humidity,
                            HumiditySetpointStatus: params.node.data.HumiditySetpointStatus
                        };
                        returnValue = Formatters.HumiditySettingFormatterforExcel(isHumidity);
                    }
                    break;
                case 'CondenserPressure':
                    {
                        var CondenserPressureData = {
                            ReeferOEMTypeCd: params.node.data.ReeferOEMTypeCd,
                            CondenserPressure: params.node.data.CondenserPressure
                        };
                        returnValue = Formatters.sensorDataPCondFormatterExcel(CondenserPressureData);
                    }
                    break;
                case 'EvaporatorExpansionValveOpening':
                    {
                        var EEVData = {
                            ReeferOEMTypeCd: params.node.data.ReeferOEMTypeCd,
                            EvaporatorExpansionValveOpening: params.node.data.EvaporatorExpansionValveOpening
                        };
                        returnValue = Formatters.sensorDataOpenExpFormatterExcel(EEVData);
                    }
                    break;
                case 'SuctionModulationValveOpening':
                    {
                        var SuctionModulationValveOpeningData = {
                            ReeferOEMTypeCd: params.node.data.ReeferOEMTypeCd,
                            SuctionModulationValveOpeningQualifier: params.node.data.SuctionModulationValveOpeningQualifier,
                            SuctionModulationValveOpening: params.node.data.SuctionModulationValveOpening
                        };
                        returnValue = Formatters.sensorDataOpenSucFormatterForExcel(SuctionModulationValveOpeningData);
                    }
                    break;
                case "ThreePhaseCurrent": returnValue = Formatters.Current3PhaseFormatterforExcel(params.value); break;
                case "FilerepositoryActionCD":
                    {
                        if (params.value != null && params.value != undefined && params.value != '' && params.value != "null")
                            returnValue = Formatters.GetFileRepositoryActionDesc(params.node.data.FilerepositoryActionCD);
                        else
                            return "-NA-";
                    }
                    break;
                case "GPSCoords":
                    return Formatters.GPSCoordsFormatterGroupingForExcel(params);
                case 'HumiditySetpoint':
                    {
                        if (params.value != null && params.value != undefined && params.value != '' && params.value != "null")
                            returnValue = Formatters.HumiditySetpointForExcel(params.value, params.node.data.HumiditySetpointStatus);
                        else
                            return "-NA-";

                        //returnValue = Formatters.HumiditySetpointForExcel(params.value);
                    }
                    break;
                case 'DoorOpen':
                    {
                        if (params.value != undefined && params.value != null) {
                            returnValue = Formatters.DeviceDoorFormatterExcel(params.value);
                        }
                    }
                    break;
                case 'Auth0_OrgId':
                    {
                            returnValue = Formatters.Auth0MigratedYesNoConverterForExcel(params.value);
                    }
                    break;
                default: {
                    if (params.value != null && params.value != undefined && params.value != '' && params.value != "null") {
                        return params.value;
                    }
                    else if (params.column.colId === "0") {
                        return "";
                    }
                    else
                        return "-NA-";
                }
            }

            return returnValue;
        }
    }

    myGroupHeaderCallback(params) {

        var displayName = params.columnApi.getDisplayNameForColumnGroup(
            params.columnGroup
        );
        return displayName;
    }

    myHeaderCallback(params) {
        var headerDisplayName = params.column.getColDef().headerName;
        switch (headerDisplayName) {
            case "Event Time": case "Reported Time": case "Created On": case "Last Modified On": case "Last Updated On": case "Updated On": case "Created Time": case "Modified Time":
            case 'StatusDate': case 'Submitted Dt': case 'Expiration Dt': case 'Status Time': case 'Submitted Time': case 'Expiration Time': case 'Created on': case 'Updated on': case "Door time":
            case "Event time": case "Receipt time"://RCNG-1143
                return Formatters.TimeZoneFormatter(headerDisplayName);
            case "Device temp. ": case "Device temp "://RCNG-1143
                return Formatters.TemperatureHeaderFormatter(headerDisplayName);            
            default:
                return headerDisplayName;
        }
    }

    myRowGroupCallback(params) {
        var indent = '--';
        var node = params.node;
        //var label = node.key.toUpperCase();

        var label = self.getGroupDisplayValueName(params);
        if (!node.parent.parent) {
            return label; // top level node, parent is root node
        }
        label = '> ' + label;
        // indent once per level in the row group hierarchy
        while (node.parent.parent) {
            label = indent + label;
            node = node.parent;
        }
        return label;

    }  

    closeToolBarModel() {
        $('#' + this.props.formName).hide();
    }

    EmailTo() {
        if (this.props.gridData != undefined && this.props.gridData != null && this.props.gridData.length > 0) {
            if (this.props.sourceFrom == 'Dashboard') {
                this.props.renderEmailDialog(this.props.gridData, this.props.colDefs, this.props.formName, this.props.parentchild);
            }
            else {
                this.setState({ renderEmailHtml: this.renderEmailControl() });
                $('#' + this.props.formName).show();
            }
        }
        else {
            PopupWindow.showErrorMessage("Alert", "No Data to Email.");
        }
    }

    renderSheets() {
        this.setState({ sheetInfo: this.generateSheetInfo() }, () => this.checkToFileDownload());
    }

    checkToFileDownload() {
        if (this.state.isDownload) {
            $('#btnDownloadExcelGridToolBar').click();
            $("#globalLoader").hide();
            PopupWindow.showErrorMessage("Alert", "Data exported successfully.");
            this.setState({ isDownload: false });
        }
    }

    getSheetInfo(headerName: string) {
        var headerInfo = headerName.replace(/\s+/g, '');
        var removeDotInHeader = headerInfo.split('.').join('');
        var removeNInHeader = removeDotInHeader.replace('/n', '');
        var removeHashInHeader = removeNInHeader.replace('#', '');
        var removeUTCInHeader = removeHashInHeader.replace('(UTC)', '');
        var finalHeaderColumn = removeUTCInHeader.replace('(°C)', '');
        return <Workbook.Column label={headerName} value={finalHeaderColumn} />;
    }

    generateSheetInfo() {
        var columnInfo = [];
        if (this.state.headerData != null && this.state.headerData.length > 0) {
            $.each(this.state.headerData, function (i, iVal) {
                var sheetObject = self.getSheetInfo(iVal.headerName);
                columnInfo.push(sheetObject);
            });
        }

        return <Workbook.Sheet data={this.state.excelData} name="Sheet1">
            {columnInfo}
        </Workbook.Sheet>;
    }

    downloadExcel(formName: string, isFileDownload: boolean) {
        var currentDate = new Date();
        self.setState({
            fileTitle: formName + currentDate.getDate() + currentDate.getMonth() + currentDate.getFullYear() + currentDate.getHours() + currentDate.getMinutes() + currentDate.getSeconds(),
            isDownload: isFileDownload
        }, () => self.renderSheets());
    }

    ClearQuickFilter() {
        $("#GridToolbarfilter").val('');
        this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.setQuickFilter('');
    }

    static applySheetData(sheetData: any, formName: string) {
        self.setState({ excelData: sheetData.ColumnData, headerData: sheetData.HeaderData }, () => self.downloadExcel(formName == '' ? self.props.formName : formName, true));
    }
   onQuickFilterChanged(event: any) {
        this.props.gridApiParams.gridOptionsWrapper.gridOptions.api.setQuickFilter(event.target.value);
    }
    public render() {
        return <div className="GridToolBarParent">
            <div className='aggrid-icons-bg'>
                <div className="btn-group aggrid-icons">
                    <button type="button" id="hidePopUpBtnRefresh" title='Refresh' className="btn btn-outline-secondary" onClick={this.RefreshData.bind(this)} ><span className='fas fa-sync-alt'></span></button>
                    <button type="button" id="hidePopUpBtnExport" title='Export to Excel' className="btn btn-outline-secondary" onClick={this.ExportToExcel.bind(this)}><span className='far fa-file-excel'></span></button>
                    <button type="button" id="hidePopUpBtnEmail" title='Email to' className="btn btn-outline-secondary" onClick={this.EmailTo.bind(this)}><span className='fa fa-envelope'></span></button>
                    <Workbook filename={this.state.fileTitle + ".xlsx"} element={<button id="btnDownloadExcelGridToolBar" className="btn-lg btn btn-outline-secondary d-none"></button>}>
                        {this.state.sheetInfo}
                    </Workbook>
                </div>
            </div>
           
            {this.props.formName == "UserSearch" || this.props.formName == "GroupManagement" || this.props.formName == "CargoCareProfiles" || this.props.formName == "SubcriptionManager" ?
                <div className={this.props.formName == "UserSearch" ? 'QuickFilterUser' : this.props.formName == "GroupManagement" ? 'QuickFilterGroup' : this.props.formName == "CargoCareProfiles" ? 'QuickFilterCargoCare' : this.props.formName == "SubcriptionManager" ? 'QuickFilterSubcription' : ""}>
                    <input type='text' id='GridToolbarfilter' name="focus" className='form-control search-box' placeholder='Quick Filter' title='Enter a value to filter the grid below. The value will be compared to all fields.' onChange={e => this.onQuickFilterChanged(e)} required />
                    <button type="reset" className="close-icon" onClick={this.ClearQuickFilter.bind(this)}></button>
                </div> : ""}

            {this.modelDialogHtml()}
        </div>
    }
}